import React from "react";

const CameraIcon = () => {
  return (
    <>
      <svg width="20" height="18.182" viewBox="0 0 20 18.182">
        <path
          id="Path_2519"
          data-name="Path 2519"
          d="M2.818,19.182a1.75,1.75,0,0,1-1.284-.534A1.754,1.754,0,0,1,1,17.364V6.455a1.749,1.749,0,0,1,.535-1.284,1.755,1.755,0,0,1,1.284-.535H5.682L7.364,2.818h5.455V4.636H8.159L6.5,6.455H2.818V17.364H17.364V9.182h1.818v8.182a1.822,1.822,0,0,1-1.818,1.818ZM17.364,6.455V4.636H15.545V2.818h1.818V1h1.818V2.818H21V4.636H19.182V6.455ZM10.091,16a4.072,4.072,0,0,0,4.091-4.091,4.074,4.074,0,0,0-4.091-4.091A4.075,4.075,0,0,0,6,11.909,4.074,4.074,0,0,0,10.091,16m0-1.818a2.251,2.251,0,0,1-2.273-2.273,2.251,2.251,0,0,1,2.273-2.273,2.251,2.251,0,0,1,2.273,2.273,2.251,2.251,0,0,1-2.273,2.273"
          transform="translate(-1 -1)"
          fill="gray"
        />
      </svg>
    </>
  );
};

export default CameraIcon;
